<template>
    <div class="flex min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors duration-300">
      <!-- Sidebar -->
      <HrSidebar :isOpen="isSidebarOpen" />
  
      <!-- Main Content -->
      <main 
        class="flex-1 overflow-x-hidden transition-all duration-300"
        :class="{'ml-64': isSidebarOpen, 'ml-0': !isSidebarOpen}"
      >
        <!-- Navbar -->
             <header 
        class="fixed top-0 z-50 w-full bg-white dark:bg-gray-800 shadow-sm transition-all duration-300"
      >
        <HrTopbar 
          :page-title="currentPageTitle"
          :is-sidebar-open="isSidebarOpen"
          :is-dark-mode="isDarkMode"
          @toggle-sidebar="toggleSidebar"
          @toggle-dark-mode="toggleDarkMode"
        />
      </header>
  
        <!-- Content Area -->
        <div class="p-6 max-w-full">
          <div class="flex justify-between items-center mb-8">
            <div class="flex items-center space-x-4">
              <span class="text-gray-600 dark:text-gray-300">Last updated: {{ currentDate }}</span>
              <button 
                @click="refreshData"
                class="p-2 rounded-full bg-white dark:bg-gray-700 shadow hover:bg-gray-100 dark:hover:bg-gray-600"
              >
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-600 dark:text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                </svg>
              </button>
            </div>
          </div>

  
          <!-- Stats Cards -->
          <div class="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8 p-4">
            <!-- Total Staff -->
            <div class="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-md border-l-4 border-[#035a76]">
              <div class="flex justify-between items-center">
                <div>
                  <p class="text-sm font-medium text-[#035a76] dark:text-[#035a76]">Total Staff</p>
<p class="text-2xl font-bold text-[#035a76] mt-1">{{ summary.totalHired }}</p>
                </div>
                <div class="p-3 rounded-full bg-blue-100 dark:bg-[#035a76]/50 text-[#035a76] dark:text-[#035a76]">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                  </svg>
                </div>
              </div>
              <p class="text-xs text-[#035a76] dark:text-[#035a76] mt-2">All Hired Applicants</p>
            </div>
  
            <!-- Hired -->
            <div class="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-md border-l-4 border-green-500">
              <div class="flex justify-between items-center">
                <div>
                  <p class="text-sm font-medium text-[#035a76] dark:text-[#035a76]">Complteted Checklist</p>
<p class="text-2xl font-bold text-[#035a76] mt-1">{{ summary.completedChecklist }}</p>                
</div>
                <div class="p-3 rounded-full bg-green-100 dark:bg-green-900/50 text-green-600 dark:text-green-400">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                  </svg>
                </div>
              </div>
              <p class="text-xs text-[#035a76] dark:text-[#035a76] mt-2">Successfully Completed all process</p>
            </div>
  
            <!-- Rejected -->
            <div class="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-md border-l-4 border-red-500">
              <div class="flex justify-between items-center">
                <div>
                  <p class="text-sm font-medium text-[#035a76] dark:text-[#035a76]">Uncompeted Staff</p>
<p class="text-2xl font-bold text-[#035a76] mt-1">{{ summary.uncompletedChecklist }}</p>
                </div>
                <div class="p-3 rounded-full bg-red-100 dark:bg-red-900/50 text-red-600 dark:text-red-400">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </div>
              </div>
              <p class="text-xs text-[#035a76] dark:text-[#035a76] mt-2">Total number of uncompleted checklist staff</p>
            </div>
  
            <!-- Kept -->
            <div class="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-md border-l-4 border-yellow-500">
              <div class="flex justify-between items-center">
                <div>
                  <p class="text-sm font-medium text-[#035a76] dark:text-[#035a76]">Total Number of Process</p>
<p class="text-2xl font-bold text-[#035a76] mt-1">{{ summary.totalProcesses }}</p>                </div>
                <div class="p-3 rounded-full bg-yellow-100 dark:bg-yellow-900/50 text-yellow-600 dark:text-yellow-400">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
              </div>
              <p class="text-xs text-[#035a76] dark:text-[#035a76] mt-2">Applicants on hold</p>
            </div>
          </div>
  

          <!-- Filter Tabs -->
  
<div class="bg-white dark:bg-gray-800 shadow-lg rounded-2xl p-6 mb-6 border border-gray-100 dark:border-gray-700">

  <!-- Header -->
  <div class="flex justify-between items-center mb-6">
    <div>
      <h2 class="text-lg font-semibold text-gray-800 dark:text-white">
        Filter Applicants
      </h2>
      <p class="text-sm text-gray-500 dark:text-gray-400">
        Narrow down applicants using the filters below
      </p>
    </div>
  </div>

  <!-- Filters Grid -->
  <div class="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-4">

    <!-- Status -->
    <!-- <div>
<label class="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">Status</label>
      <select v-model="filters.status" 
      class="w-full border border-gray-300 dark:border-gray-600 rounded-lg px-3 py-2
       focus:ring-2 focus:ring-[#74bd54] focus:outline-none
       dark:bg-gray-700 dark:text-white transition">
        <option value="">All Status</option>
        <option v-for="tab in tabs" :key="tab" :value="tab">
          {{ tab }}
        </option>
      </select>
    </div> -->

    <!-- Position -->
    <div>
      <label class="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">Position</label>
      <select v-model="filters.position" 
      class="w-full border border-gray-300 dark:border-gray-600 rounded-lg px-3 py-2
       focus:ring-2 focus:ring-[#74bd54] focus:outline-none
       dark:bg-gray-700 dark:text-white transition">
        <option value="">All Positions</option>
        <option 
          v-for="pos in positions" 
          :key="pos.id" 
          :value="pos.position_name"
        >
          {{ pos.position_name }}
        </option>
      </select>
    </div>

    <!-- Period -->
    <div>
      <label class="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">Period</label>
      <select v-model="filters.period" 
      class="w-full border border-gray-300 dark:border-gray-600 rounded-lg px-3 py-2
       focus:ring-2 focus:ring-[#74bd54] focus:outline-none
       dark:bg-gray-700 dark:text-white transition">
        <option value="">All Terms</option>
        <option v-for="p in periods" :key="p" :value="p">
          {{ p }}
        </option>
      </select>
    </div>

    <!-- Month -->
    <div>
      <label class="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">Month</label>
      <select v-model="selectedMonth" 
      class="w-full border border-gray-300 dark:border-gray-600 rounded-lg px-3 py-2
       focus:ring-2 focus:ring-[#74bd54] focus:outline-none
       dark:bg-gray-700 dark:text-white transition">
        <option value="">All Months</option>
        <option v-for="m in months" :key="m.value" :value="m.value">
          {{ m.name }}
        </option>
      </select>
    </div>

    <!-- Year -->
    <div>
      <label class="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">Year</label>
      <select v-model="selectedYear"
      class="w-full border border-gray-300 dark:border-gray-600 rounded-lg px-3 py-2
       focus:ring-2 focus:ring-[#74bd54] focus:outline-none
       dark:bg-gray-700 dark:text-white transition">
        <option value="">All Years</option>
        <option v-for="y in years" :key="y" :value="y">
          {{ y }}
        </option>
      </select>
    </div>

    <!-- Search -->
    <div>
      <label class="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">Search</label>
      <div class="relative">
        <input
          v-model="filters.search"
          type="text"
          placeholder="Search name or position..."
         class="w-full border border-gray-300 dark:border-gray-600 rounded-lg px-3 py-2
       focus:ring-2 focus:ring-[#74bd54] focus:outline-none
       dark:bg-gray-700 dark:text-white transition"
        />
        <!-- Icon -->
        <svg class="w-4 h-4 absolute left-3 top-3 text-gray-400" fill="none" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-4.3-4.3m1.8-5.2a7 7 0 11-14 0 7 7 0 0114 0z"/>
        </svg>
      </div>
    </div>
    <div>
    <div class="flex space-x-3 mt-6">
      <button
        @click="resetFilters"
        class="px-4 py-2 rounded-lg border border-gray-300 dark:border-gray-600 
               text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition"
      >
        Reset
      </button>

      <button
        @click="applyFilters"
        class="px-6 py-2 rounded-lg bg-[#74bd54] text-white 
               shadow-md hover:shadow-lg hover:scale-[1.02] transition"
      >
        Apply Filters
      </button>
    </div>
    </div>
  </div>

  <!-- Actions -->
  <div class="flex justify-between items-center mt-6 border-t pt-4 dark:border-gray-700">

    <!-- Left (optional future use) -->
    <div class="text-sm text-gray-500 dark:text-gray-400">
      {{ filteredApplicants.length }} results found
    </div>

    <!-- Buttons -->
    <!-- <div class="flex space-x-3">
      <button
        @click="resetFilters"
        class="px-4 py-2 rounded-lg border border-gray-300 dark:border-gray-600 
               text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition"
      >
        Reset
      </button>

      <button
        @click="applyFilters"
        class="px-6 py-2 rounded-lg bg-[#74bd54] text-white 
               shadow-md hover:shadow-lg hover:scale-[1.02] transition"
      >
        Apply Filters
      </button>
    </div> -->

  </div>
</div>

  
          <!-- Applicants Table -->
          <div class="overflow-x-auto bg-white dark:bg-gray-800 shadow rounded-lg">
            <table class="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
              <thead class="bg-gray-100 dark:bg-gray-700">
                <tr>
                  <th class="px-6 py-3 text-left text-xs font-medium text-gray-600 dark:text-gray-300 uppercase tracking-wider">Name</th>
                  <th class="px-6 py-3 text-left text-xs font-medium text-gray-600 dark:text-gray-300 uppercase tracking-wider">Position</th>
                  <th class="px-6 py-3 text-left text-xs font-medium text-gray-600 dark:text-gray-300 uppercase tracking-wider">Status</th>
                  <th class="px-6 py-3 text-left text-xs font-medium text-gray-600 dark:text-gray-300 uppercase tracking-wider">Interview Period</th>
                  <th class="px-6 py-3 text-left text-xs font-medium text-gray-600 dark:text-gray-300 uppercase tracking-wider">Date</th>
                  <th class="px-6 py-3 text-left text-xs font-medium text-gray-600 dark:text-gray-300 uppercase tracking-wider">Complted</th>
                  <th class="px-6 py-3 text-left text-xs font-medium text-gray-600 dark:text-gray-300 uppercase tracking-wider">Action</th>
                </tr>
              </thead>
              <tbody class="divide-y divide-gray-200 dark:divide-gray-700">
                <tr v-for="applicant in filteredApplicants" :key="applicant.id">
                  <td class="px-6 py-4 text-sm text-gray-900 dark:text-white">{{ applicant.name }}</td>
                  <td class="px-6 py-4 text-sm text-gray-600 dark:text-gray-300">{{ applicant.position }}</td>
                  <td class="px-6 py-4">
                    <span 
                      :class="{
                        'bg-green-100 text-green-800': applicant.status === 'Hired',
                        'bg-yellow-100 text-yellow-800': applicant.status === 'Kept',
                        'bg-red-100 text-red-800': applicant.status === 'Rejected',
                        'bg-blue-100 text-blue-800': applicant.status === 'Processing'
                      }"
                      class="px-2 py-1 rounded-full text-xs font-medium"
                    >
                      {{ applicant.status }}
                    </span>
                  </td>
                  <td class="px-6 py-4 text-sm text-gray-600 dark:text-gray-300">{{ applicant.period }} </td>
                  <td class="px-6 py-4 text-sm text-gray-600 dark:text-gray-300">{{ applicant.date }}</td>
                  <td class="px-6 py-4 text-sm">
                    <span
                      :class="[
                        'px-2 py-1 rounded text-xs font-medium',
                        applicant.completed_process_count === applicant.total_processes
                          ? 'bg-green-100 text-green-700'
                          : 'bg-yellow-100 text-yellow-700'
                      ]"
                    >
                      {{ applicant.completed_process_count }} / {{ applicant.total_processes }}
                    </span>
                  </td>                  
                  <td>
                 <button
                   v-if="hasPermission('checklist', 'view_checklist')"
                  @click="openCheckListModal(applicant)" 
                  class="text-sm text-secondary text-left hover:underline dark:text-blue-400">
                  <i class="fas fa-eye"></i>
                </button>
                </td>
                </tr>
              </tbody>
            </table>
          </div>
  
          <!-- Modals -->
          <Teleport to="body">
            <ChecklistModal
              v-if="selectedApplicant"
              :applicant="selectedApplicant"
              @close="selectedApplicant = null"
              @save="handleChecklistSave"
            />           
          </Teleport>
        </div>
      </main>
    </div>
  </template>
  
  <script setup>
  import { ref, computed, onMounted, watch } from 'vue';
  import api from '@/services/api';
import 'vue-multiselect/dist/vue-multiselect.css'
  import HrSidebar from '@/components/hr/HrSidebar.vue';
  import HrTopbar from '@/components/hr/HrTopbar.vue';
import ChecklistModal from '@/components/hr/ChecklistModal.vue';

import { usePermissions } from '@/composables/usePermissions'

const { hasPermission } = usePermissions()






  
  const tabs = ['All', 'Hired', 'Rejected', 'Kept', 'Processing'];
  const activeTab = ref('All');
  const searchQuery = ref('');
  const isSidebarOpen = ref(true);
  const isDarkMode = ref(false);
  const currentPageTitle = ref('Process Checklist');
  const showActionModal = ref(false);
  const showViewModal = ref(false);
  const selectedApplicant = ref(null);
  const actionStatus = ref('');

    const showFilter = ref(false);

    const positions = ref([]);

const cvInput = ref(null);

  const applicants = ref([]);

  const agencies = ref([]);

  const staffMembers = ref([]);

  const selectedStaff = ref(null)

watch(selectedStaff, (val) => {
  newApplicant.value.inward_id = val ? val.id : ''
})

  

const filters = ref({
  status: '',
  position: '',
  period: '',
  date: '',
  search: ''
});

const periods = ref([
  'First Term',
  'Second Term',
  'Third Term'
]);

const selectedMonth = ref('');
const selectedYear = ref('');
  

const months = [
  { value: '01', name: 'January' },
  { value: '02', name: 'February' },
  { value: '03', name: 'March' },
  { value: '04', name: 'April' },
  { value: '05', name: 'May' },
  { value: '06', name: 'June' },
  { value: '07', name: 'July' },
  { value: '08', name: 'August' },
  { value: '09', name: 'September' },
  { value: '10', name: 'October' },
  { value: '11', name: 'November' },
  { value: '12', name: 'December' }
];

const years = computed(() => {
  const unique = new Set();

  applicants.value.forEach(app => {
    if (app.date) {
      const year = app.date.split('-')[0]; 
      unique.add(year);
    }
  });

  return Array.from(unique);
});
const resetFilters = () => {
  filters.value = {
    status: '',
    position: '',
    period: '',
    date: '',
    search: ''
  };
};


  const newApplicant = ref({
    name: '',
    position_id: '',
    email:'',
    phone: '',
    status: '',
    entry_status: '',
    period: '',
  recommendation: '',
  agency_id: '',
  inward_id: '',
    cv: '',
    comment: ''
  });



  const fetchPositions = async () => {
  try {
    const response = await api.get("Positions.php");

    positions.value = response.data.map(position => ({
      id: position.id,
      department_id: position.department_id,
      department_name : position.department_name,
      position_name: position.title,
      code: position.code,
      description: position.description
    }));

  } catch (error) {
    console.error("Error fetching Positions:", error);
  }
}

const fetchAgencies = async () => {
  try{
    const response = await api.get("Agencies.php");
    agencies.value = response.data.map(agency => ({
      id:agency.id,
      name:agency.name,
      code:agency.code,
      description:agency.description
    }));

  } catch (error) {
    console.error("Error fetching Agencies:", error);
  }
};


const fetchApplicants = async () => {
  try {
    const response = await api.get("CheckListStaff.php");

    applicants.value = response.data.applicants.map(applicant => ({
      id: applicant.id,
      name: applicant.full_name,
      position: applicant.position_title,
      status: applicant.applicant_status,
      applicant_status: applicant.applicant_status,
      entry_status: applicant.entry_status,
      period: applicant.period,
      date: applicant.created_at,
      cv: applicant.cv_file_path,
      comment: applicant.applicant_comment,

      completed_process_count: Number(applicant.completed_process_count),
      total_processes: Number(applicant.total_processes)
    }));

    summary.value = response.data.summary;

  } catch (error) {
    console.error("Error fetching Applicants:", error);
  }
};

const fetchInward = async () => {
  try {
    const response = await api.get('get_hired_applicants.php');

    console.log(response.data);

    staffMembers.value = response.data.data.map(item => ({
      id: item.applicant_id,
      full_name: item.full_name,
      email: item.email,
      position_title: item.position?.position_title,
      section_name: item.section?.section_name,
      class_name: item.class?.class_name,
      joining_date: item.contract?.joining_date,
      status: item.applicant_status
    }));

  } catch (error) {
    console.error('Error fetching staff members:', error);
  }
};

  const currentDate = computed(() => {
    return new Date().toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  });
  
const filteredApplicants = computed(() => {
  return applicants.value
    // .filter(applicant => applicant.entry_status === 'New')
    .filter(applicant => {

      const matchMonth =
        !selectedMonth.value ||
        applicant.date?.split('-')[1] === selectedMonth.value;

      const matchYear =
        !selectedYear.value ||
        applicant.date?.split('-')[0] === selectedYear.value;

      const matchPeriod =
        !filters.value.period ||
        applicant.period === filters.value.period;

      const matchPosition =
        !filters.value.position ||
        applicant.position === filters.value.position;

      const matchSearch =
        !filters.value.search ||
        applicant.name.toLowerCase().includes(filters.value.search.toLowerCase());

      return (
        matchMonth &&
        matchYear &&
        matchPeriod &&
        matchPosition &&
        matchSearch
      );
    });
});
  const summary = computed(() => {
  const totalStaff = applicants.value.length;

  const hiredApplicants = applicants.value.filter(app => app.status === 'Hired');
  const totalHired = hiredApplicants.length;

 
  let completedChecklist = 0;
  let uncompletedChecklist = 0;

  hiredApplicants.forEach(app => {
    const completed = app.completed_process_count ?? 0; 
    const totalProcesses = app.total_processes ?? 0;

    if (completed >= totalProcesses && totalProcesses > 0) {
      completedChecklist++;
    } else {
      uncompletedChecklist++;
    }
  });

  const totalProcesses = applicants.value[0]?.total_processes ?? 0;

  return {
    totalStaff,
    totalHired,
    completedChecklist,
    uncompletedChecklist,
    totalProcesses
  };
});
 // Open Checklist Modal
  const openCheckListModal = (applicant) => {
  selectedApplicant.value = applicant;
};
// Update Checklist Modal
const handleChecklistSave = (checkedIds) => {
  console.log('Completed processes:', checkedIds);
  fetchApplicants();
 
};
  
  const toggleSidebar = () => {
    isSidebarOpen.value = !isSidebarOpen.value;
  };
  
  const toggleDarkMode = () => {
    isDarkMode.value = !isDarkMode.value;
    if (isDarkMode.value) {
      document.documentElement.classList.add('dark');
      localStorage.theme = 'dark';
    } else {
      document.documentElement.classList.remove('dark');
      localStorage.theme = 'light';
    }
  };
  
  const refreshData = () => {
    console.log('Refreshing data...');
  };

  onMounted(() => {
fetchPositions();
fetchApplicants();
fetchAgencies();
fetchInward();
  });
  </script>
  <style>
filter-enter-active,
.filter-leave-active {
  transition: all 0.35s ease;
}

.filter-enter-from,
.filter-leave-to {
  opacity: 0;
  transform: translateY(-15px);
  max-height: 0;
}

.filter-enter-to,
.filter-leave-from {
  opacity: 1;
  transform: translateY(0);
  max-height: 1000px;
}

</style>